// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"162":"wide-components","447":"narrow-components","737":"resize-observer-polyfill","992":"reports"}[chunkId] || chunkId) + "." + {"162":"2c2e09e4","171":"491e33e7","383":"d7919241","447":"b48d7cb2","737":"68c3249b","969":"b56f4e53","992":"2402a148"}[chunkId] + ".chunk.js";
};